import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCity } from '@fortawesome/free-solid-svg-icons/faCity';
import type { IconProps } from '../../types';

export function CityIcon({ 
  className, 
  size = 24, 
  color,
  'aria-label': ariaLabel = 'City',
}: IconProps) {
  return (
    <FontAwesomeIcon 
      icon={faCity}
      className={className}
      style={{ 
        width: typeof size === 'number' ? size : undefined,
        height: typeof size === 'number' ? size : undefined,
      }}
      color={color}
      aria-label={ariaLabel}
      role="img"
    />
  );
}
